import Button from '../../../../components/Button'
import QuestionAndAnswer from './components/QuestionAndAnswer'
import SignUpNow from './components/SignUpNow'
import Hero from './Sections/Hero'
import junior_seniority_example from './images/junior_seniority_example.svg'
import skills_example from './images/skills_example.svg'
import work_experience_example from './images/work_experience_example.svg'
import firm from './images/firm.svg'
import search_banner from './images/search_banner.svg'
import search_banner_mobile from './images/search_banner_mobile.svg'
import { openNewTab } from '../../../../utils'
import DashboardWrapper from '../../../Dashboard/components/DashboardWrapper'
import useResize from '../../../../hooks/useResize'
import { OUT_OF_THE_APP, VIEWPORT_LG } from '../../../../utils/constants'
import NavbarHutritNext from './components/NavbarHutritNext'
import { useNavigate } from 'react-router-dom'

const HutritNext = () => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const navigate = useNavigate()

  return OUT_OF_THE_APP ? (
    <>
      <NavbarHutritNext />
      <Hero />
      <div
        className="mx-auto"
        style={{
          width: isMobile ? '' : '85%',
          padding: isMobile ? '0px 25px' : ''
        }}
      >
        <div id="firstQuestion" className="lumpy-background">
          <QuestionAndAnswer
            questionText="HOLA, FUTURO TALENTO"
            answerText="Sabemos que el comienzo de tu carrera puede ser emocionante... y también abrumador. No tener experiencia, no saber por dónde empezar o no encontrar empresas que te den una oportunidad real es frustrante. Por eso creamos Hutrit Next: un programa pensado para ti, que estás dando tus primeros pasos y quieres aprender, crecer y demostrar de lo que eres capaz."
          />
        </div>
        <div id="secondQuestion" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿QUÉ ES HUTRIT NEXT?"
            //eslint-disable-next-line
            answerText={`Hutrit Next es un programa de prácticas remuneradas para perfiles internacionales que quieren trabajar en \n startups y empresas en España. Buscamos personas como tú: con formación en tecnología o marketing, \n muchas ganas de aprender y crecer, pero que todavía no han tenido la oportunidad de tener experiencia real \n en una empresa.`}
          />
        </div>
        <div id="questionThree" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿CÓMO FUNCIONA EL PROGRAMA?"
            //eslint-disable-next-line
            answerJsx={
              <div>
                <div className="text-on-bg-primary text-center text-lg-start">
                  El programa está dividido en tres fases de 4 meses, es decir,
                  un total de 12 meses (aunque puedes participar{' '}
                  <br className="d-lg-flex d-none" /> solo en una fase si así lo
                  prefieres):
                </div>
                <ul>
                  <li className="text-on-bg-primary mt-3">
                    <strong
                      style={{
                        color: '#01A76A',
                      }}
                    >
                      Fase 1 (0-4 meses)
                    </strong>
                    <strong className="text-on-bg-primary mx-1">
                      – Estás aprendiendo.
                    </strong>
                    Conoces la empresa, las herramientas, los procesos. Te{' '}
                    <br />
                    acompañamos semana a semana con tareas, seguimiento y
                    feedback. <br /> Remuneración: 300 EUR/mes
                  </li>
                  <li className="text-on-bg-primary mt-3">
                    <strong
                      style={{
                        color: '#01A76A',
                      }}
                    >
                      Fase 2 (4-8 meses)
                    </strong>
                    <strong className="text-on-bg-primary mx-1">
                      – Ya te mueves con más soltura.
                    </strong>
                    Eres más independiente y empiezas a aportar más <br />{' '}
                    valor. <br />
                    Remuneración: 500 EUR/mes
                  </li>
                  <li className="text-on-bg-primary mt-3">
                    <strong
                      style={{
                        color: '#01A76A',
                      }}
                    >
                      Fase 3 (8-12 meses)
                    </strong>
                    <strong className="text-on-bg-primary mx-1">
                      – Eres parte del equipo.
                    </strong>
                    Participas activamente en tareas importantes y aportas{' '}
                    <br /> como uno más. <br /> Remuneración: 800 EUR/mes
                  </li>
                </ul>
                <span className="text-on-bg-primary mt-3">
                  Al finalizar el programa, si tú y la empresa estáis felices,
                  te ayudamos con la contratación indefinida.
                </span>
              </div>
            }
          />
        </div>
        <div id="questionFour" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿QUÉ INCLUYE EL PROGRAMA?"
            answerJsx={
              <ul className="text-on-bg-primary">
                <li>Una empresa real que te acoge como parte de su equipo</li>
                <li>Un plan de tareas adaptado a ti</li>
                <li>
                  Una plataforma donde ver tu progreso y recibir feedback
                  semanal
                </li>
                <li>Un equipo que te acompaña y te apoya en todo el camino</li>
                <li>Una carta de recomendación al finalizar</li>
                <li>
                  Y sí: un sueldo mensual, porque tu tiempo y tu esfuerzo valen
                </li>
              </ul>
            }
          />
        </div>
        <div id="questionFive" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿QUÉ ESPERAMOS DE TI?"
            answerJsx={
              <div>
                <div className="text-on-bg-primary text-lg-start text-center">
                  Solo tres cosas:
                </div>
                <ol className="text-on-bg-primary">
                  <li>Que tengas ganas de aprender.</li>
                  <li>Que te tomes en serio esta oportunidad.</li>
                  <li>
                    Que seas honesto con tus dudas y necesidades (nosotros te
                    ayudamos).
                  </li>
                </ol>
              </div>
            }
          />
        </div>
        <div id="questionFive" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿PARA QUIÉN ES ESTO?"
            answerJsx={
              <div>
                <ul className="text-on-bg-primary">
                  <li>
                    Para quien quiere{' '}
                    <strong>empezar su carrera profesional</strong> pero no
                    consigue oportunidades.
                  </li>
                  <li>
                    Para quien <strong>sabe mucho en teoría</strong>, pero
                    necesita práctica real.
                  </li>
                  <li>
                    Para quien <strong>está comprometido con su futuro</strong>{' '}
                    y quiere crecer, paso a paso.
                  </li>
                </ul>
                <div className="text-on-bg-primary text-center text-lg-start">
                  No necesitas tener experiencia laboral, solo actitud. Si has
                  estudiado algo relacionado con tecnología o <br /> marketing
                  (o te has formado por tu cuenta), este programa es para ti.
                </div>
              </div>
            }
          />
        </div>
        <div id="questionSix" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿Y SI ME DA MIEDO NO ESTAR A LA ALTURA?"
            answerJsx={
              <div className="d-flex flex-column gap-4">
                <div className="text-on-bg-primary text-center text-lg-start">
                  Es normal. Pero por eso Hutrit Next no es solo una práctica.
                  Es un proceso de formación, acompañamiento y <br /> mejora
                  continua. Te ayudamos a ir creciendo poco a poco, sin presión,
                  y adaptándonos a ti.
                </div>
                <div className="text-on-bg-primary text-center text-lg-start">
                  No buscamos talento perfecto. Buscamos talento con ganas.
                </div>
              </div>
            }
          />
        </div>
        <div id="questionSeven" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿Y SI QUIERO APUNTARME?"
            answerJsx={
              <div className="d-flex flex-column">
                <span className="text-on-bg-primary">
                  Muy fácil. Solo tienes que registrarte en nuestra plataforma:
                </span>
                <div className="mt-4 mb-4 d-flex justify-content-center">
                  <Button
                    onClick={() =>
                      openNewTab({ url: '/register-talent-hutrit-next' })
                    }
                  >
                    Quiero apuntarme al programa
                  </Button>
                </div>
                <span className="text-on-bg-primary text-center">
                  Una vez dentro:
                </span>
                <ul className="text-on-bg-primary">
                  <li>Completas tu perfil</li>
                  <li>Nos cuentas en qué te gustaría trabajar</li>
                  <li>Te mostraremos empresas que buscan personas como tú</li>
                  <li>
                    Y si hay un match… ¡empiezas tu primer reto profesional!
                  </li>
                </ul>
              </div>
            }
          />
        </div>
        <div id="questionEight" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿CÓMO TENER UN PERFIL DE IMPACTO?"
            answerJsx={
              <div className="d-flex flex-column align-items-center">
                <span className="text-on-bg-primary text-center text-lg-start">
                  Aprovecha al máximo tu experiencia con un perfil que te
                  representa auténticamente. Observa cómo lo hacemos <br /> en
                  nuestro ejemplo destacado.
                </span>
                <img
                  src={junior_seniority_example}
                  width={isMobile ? 300 : 664}
                  className="mt-5"
                />
                <img
                  src={skills_example}
                  width={isMobile ? 300 : 664}
                  className="mt-5 mb-5"
                />
                <img
                  src={work_experience_example}
                  width={isMobile ? 300 : 664}
                />
              </div>
            }
          />
        </div>
        <div id="questionNine" className="lumpy-background">
          <QuestionAndAnswer
            questionText="EN RESUMEN"
            showDivider={false}
            answerJsx={
              <div className="d-flex flex-column align-items-center gap-4">
                <span className="text-on-bg-primary text-center text-lg-start">
                  Hutrit Next es la oportunidad que muchos de nosotros habríamos
                  querido tener al empezar.
                </span>
                <span className="text-on-bg-primary text-center text-lg-start">
                  Te acompaña, te valora y te forma. Y si tú pones el esfuerzo,
                  nosotros ponemos el camino. <br /> Nos encantará conocerte.
                </span>

                <img src={firm} width={200} />
              </div>
            }
          />
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <img
            src={isMobile ? search_banner_mobile : search_banner}
            width={isMobile ? 300 : 1200}
            style={{
              marginTop: '40px',
              marginBottom: '120px',
            }}
            className="cursor-pointer"
            onClick={() => navigate('/tm-link/IzY4MC1S/es')}
          />
        </div>
      </div>
    </>
  ) : (
    <DashboardWrapper hideSidebar hideDashboardWrapper disableContinerStyles>
      <SignUpNow />
      <Hero />
      <div
        className="mx-auto"
        style={{
          width: isMobile ? '' : '85%',
        }}
      >
        <div id="firstQuestion" className="lumpy-background">
          <QuestionAndAnswer
            questionText="HOLA, FUTURO TALENTO"
            answerText="Sabemos que el comienzo de tu carrera puede ser emocionante... y también abrumador. No tener experiencia, no saber por dónde empezar o no encontrar empresas que te den una oportunidad real es frustrante. Por eso creamos Hutrit Next: un programa pensado para ti, que estás dando tus primeros pasos y quieres aprender, crecer y demostrar de lo que eres capaz."
          />
        </div>
        <div id="secondQuestion" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿QUÉ ES HUTRIT NEXT?"
            //eslint-disable-next-line
            answerText={`Hutrit Next es un programa de prácticas remuneradas para perfiles internacionales que quieren trabajar en \n startups y empresas en España. Buscamos personas como tú: con formación en tecnología o marketing, \n muchas ganas de aprender y crecer, pero que todavía no han tenido la oportunidad de tener experiencia real \n en una empresa.`}
          />
        </div>
        <div id="questionThree" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿CÓMO FUNCIONA EL PROGRAMA?"
            //eslint-disable-next-line
            answerJsx={
              <div>
                <div className="text-on-bg-primary text-center text-lg-start">
                  El programa está dividido en tres fases de 4 meses, es decir,
                  un total de 12 meses (aunque puedes participar{' '}
                  <br className="d-lg-flex d-none" /> solo en una fase si así lo
                  prefieres):
                </div>
                <ul>
                  <li className="text-on-bg-primary mt-3">
                    <strong
                      style={{
                        color: '#01A76A',
                      }}
                    >
                      Fase 1 (0-4 meses)
                    </strong>
                    <strong className="text-on-bg-primary mx-1">
                      – Estás aprendiendo.
                    </strong>
                    Conoces la empresa, las herramientas, los procesos. Te{' '}
                    <br />
                    acompañamos semana a semana con tareas, seguimiento y
                    feedback. <br /> Remuneración: 300 EUR/mes
                  </li>
                  <li className="text-on-bg-primary mt-3">
                    <strong
                      style={{
                        color: '#01A76A',
                      }}
                    >
                      Fase 2 (4-8 meses)
                    </strong>
                    <strong className="text-on-bg-primary mx-1">
                      – Ya te mueves con más soltura.
                    </strong>
                    Eres más independiente y empiezas a aportar más <br />{' '}
                    valor. <br />
                    Remuneración: 500 EUR/mes
                  </li>
                  <li className="text-on-bg-primary mt-3">
                    <strong
                      style={{
                        color: '#01A76A',
                      }}
                    >
                      Fase 3 (8-12 meses)
                    </strong>
                    <strong className="text-on-bg-primary mx-1">
                      – Eres parte del equipo.
                    </strong>
                    Participas activamente en tareas importantes y aportas{' '}
                    <br /> como uno más. <br /> Remuneración: 800 EUR/mes
                  </li>
                </ul>
                <span className="text-on-bg-primary mt-3">
                  Al finalizar el programa, si tú y la empresa estáis felices,
                  te ayudamos con la contratación indefinida.
                </span>
              </div>
            }
          />
        </div>
        <div id="questionFour" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿QUÉ INCLUYE EL PROGRAMA?"
            answerJsx={
              <ul className="text-on-bg-primary">
                <li>Una empresa real que te acoge como parte de su equipo</li>
                <li>Un plan de tareas adaptado a ti</li>
                <li>
                  Una plataforma donde ver tu progreso y recibir feedback
                  semanal
                </li>
                <li>Un equipo que te acompaña y te apoya en todo el camino</li>
                <li>Una carta de recomendación al finalizar</li>
                <li>
                  Y sí: un sueldo mensual, porque tu tiempo y tu esfuerzo valen
                </li>
              </ul>
            }
          />
        </div>
        <div id="questionFive" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿QUÉ ESPERAMOS DE TI?"
            answerJsx={
              <div>
                <div className="text-on-bg-primary text-lg-start text-center">
                  Solo tres cosas:
                </div>
                <ol className="text-on-bg-primary">
                  <li>Que tengas ganas de aprender.</li>
                  <li>Que te tomes en serio esta oportunidad.</li>
                  <li>
                    Que seas honesto con tus dudas y necesidades (nosotros te
                    ayudamos).
                  </li>
                </ol>
              </div>
            }
          />
        </div>
        <div id="questionFive" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿PARA QUIÉN ES ESTO?"
            answerJsx={
              <div>
                <ul className="text-on-bg-primary">
                  <li>
                    Para quien quiere{' '}
                    <strong>empezar su carrera profesional</strong> pero no
                    consigue oportunidades.
                  </li>
                  <li>
                    Para quien <strong>sabe mucho en teoría</strong>, pero
                    necesita práctica real.
                  </li>
                  <li>
                    Para quien <strong>está comprometido con su futuro</strong>{' '}
                    y quiere crecer, paso a paso.
                  </li>
                </ul>
                <div className="text-on-bg-primary text-center text-lg-start">
                  No necesitas tener experiencia laboral, solo actitud. Si has
                  estudiado algo relacionado con tecnología o <br /> marketing
                  (o te has formado por tu cuenta), este programa es para ti.
                </div>
              </div>
            }
          />
        </div>
        <div id="questionSix" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿Y SI ME DA MIEDO NO ESTAR A LA ALTURA?"
            answerJsx={
              <div className="d-flex flex-column gap-4">
                <div className="text-on-bg-primary text-center text-lg-start">
                  Es normal. Pero por eso Hutrit Next no es solo una práctica.
                  Es un proceso de formación, acompañamiento y <br /> mejora
                  continua. Te ayudamos a ir creciendo poco a poco, sin presión,
                  y adaptándonos a ti.
                </div>
                <div className="text-on-bg-primary text-center text-lg-start">
                  No buscamos talento perfecto. Buscamos talento con ganas.
                </div>
              </div>
            }
          />
        </div>
        <div id="questionSeven" className="lumpy-background d-none">
          <QuestionAndAnswer
            questionText="¿Y SI QUIERO APUNTARME?"
            answerJsx={
              <div className="d-flex flex-column">
                <span className="text-on-bg-primary">
                  Muy fácil. Solo tienes que registrarte en nuestra plataforma:
                </span>
                <div className="mt-4 mb-4 d-flex justify-content-center">
                  <Button
                    onClick={() =>
                      openNewTab({ url: '/register-talent-hutrit-next' })
                    }
                  >
                    Quiero apuntarme al programa
                  </Button>
                </div>
                <span className="text-on-bg-primary text-center">
                  Una vez dentro:
                </span>
                <ul className="text-on-bg-primary">
                  <li>Completas tu perfil</li>
                  <li>Nos cuentas en qué te gustaría trabajar</li>
                  <li>Te mostraremos empresas que buscan personas como tú</li>
                  <li>
                    Y si hay un match… ¡empiezas tu primer reto profesional!
                  </li>
                </ul>
              </div>
            }
          />
        </div>
        <div id="questionEight" className="lumpy-background">
          <QuestionAndAnswer
            questionText="¿CÓMO TENER UN PERFIL DE IMPACTO?"
            answerJsx={
              <div className="d-flex flex-column align-items-center">
                <span className="text-on-bg-primary text-center text-lg-start">
                  Aprovecha al máximo tu experiencia con un perfil que te
                  representa auténticamente. Observa cómo lo hacemos <br /> en
                  nuestro ejemplo destacado.
                </span>
                <img
                  src={junior_seniority_example}
                  width={isMobile ? 300 : 664}
                  className="mt-5"
                />
                <img
                  src={skills_example}
                  width={isMobile ? 300 : 664}
                  className="mt-5 mb-5"
                />
                <img
                  src={work_experience_example}
                  width={isMobile ? 300 : 664}
                />
              </div>
            }
          />
        </div>
        <div id="questionNine" className="lumpy-background">
          <QuestionAndAnswer
            questionText="EN RESUMEN"
            showDivider={false}
            answerJsx={
              <div className="d-flex flex-column align-items-center gap-4">
                <span className="text-on-bg-primary text-center text-lg-start">
                  Hutrit Next es la oportunidad que muchos de nosotros habríamos
                  querido tener al empezar.
                </span>
                <span className="text-on-bg-primary text-center text-lg-start">
                  Te acompaña, te valora y te forma. Y si tú pones el esfuerzo,
                  nosotros ponemos el camino. <br /> Nos encantará conocerte.
                </span>

                <img src={firm} width={200} />
              </div>
            }
          />
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <img
            src={search_banner}
            width={isMobile ? 300 : 1200}
            style={{
              marginTop: '40px',
              marginBottom: '120px',
            }}
          />
        </div>
      </div>
    </DashboardWrapper>
  )
}

export default HutritNext
